module.exports = __webpack_public_path__ + "static/sidemail-public--homepage-cta-bee482bd7519ade8dcad9ff05b8b269f.png";